import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { DealerLaunchStepProps } from '../types';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';
import { Button } from '../../Input/Button/Button';
import { Radio } from '../../Input/Radio/Radio';
import styles from '../styles.module.scss';

// Validation rules necessary else selecting false/no will be invalid
const showRoomValidation = {
  validate: (val: boolean) => {
    if (typeof val === 'boolean') return true;
    return 'A selection is required';
  },
};

export const DealerLaunchOnlineVirtualShowroom: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  return (
    <div
      className={classNames(styles.stepContainer, styles.virtualShowroomStep)}
    >
      <div className={styles.stepTitle}>
        Have you heard that we offer virtual vehicle tours?
      </div>
      <div className={styles.stepCard}>
        <h1>What is Virtual Showroom?</h1>
        <div className={styles.stepRow}>
          <p>
            Virtual Showroom is an online live tour tool to help connect your
            team in the showroom to customers shopping online. Watch our video
            to learn more about how Virtual Showroom connects your online
            customers to your showroom floor.
            <br />
            <br />
            Enable it today to provide live vehicle tours to customers.
          </p>
          <iframe
            className={styles.ytVideo}
            title="Virtual Showroom"
            src="https://www.youtube.com/embed/CGjdmuXPsUw"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
      <form
        onSubmit={form.handleSubmit((update) => nextStep(update))}
        className={styles.stepCard}
      >
        <h1>Would you like to offer virtual vehicle tours?</h1>
        <Radio
          className="flex-column"
          name="featureConfig.virtualShowroom.enabled"
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          form={form}
          validation={showRoomValidation}
        />
        <div className={styles.pageNav}>
          <Button
            className={styles.pageNavButton}
            label="Previous"
            onClick={prevStep}
          />
          <div className="spacer" />
          <Button
            className={styles.pageNavButton}
            label="Continue"
            type="submit"
            variant="primary"
            loading={form.formState.isSubmitting}
          />
        </div>
      </form>
    </div>
  );
};
